<template>
  <div>
    <div class="card pt-3" style="border:none">
      <div class="card-body p-1">
        <h4 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700">
          <span style="color: #9ccc65">User</span> Login
        </h4>

        <form @submit.prevent="login">
          <!-- Credentials Step -->
          <div v-if="!isAuthenticated">
            <div class="form-floating mb-3">
              <input type="text" class="form-control" v-model="username" id="username" placeholder="Username" required>
              <label for="username">Username</label>
            </div>

            <div class="form-floating mb-1">
              <input :type="passwordType" class="form-control" v-model="password" id="password" placeholder="Password" required>
              <label for="password">Password</label>
            </div>

            <label class="show-password-checkbox mb-3">
              <input type="checkbox" v-model="showPassword">
              Show Password
            </label>
          </div>

          <!-- Store Selection Step (after successful login) -->
          <div v-else class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <div class="form-floating">
                  <select class="form-select" v-model="selectedStore" id="storeSelect" aria-label="Store label select example" required>
                    <option v-for="(store,n) in stores" :key="store.id || n" :value="store">{{ store.location }}</option>
                  </select>
                  <label for="storeSelect">Select Store</label>
                </div>
              </div>
            </div>
          </div>

          <div class="text-center submit-btns">
            <button class="btn">
              {{ isAuthenticated ? 'Open App' : 'Login' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserLogin",
  data() {
    return {
      showPassword: false,
      username: '',
      password: '',
      selectedStore: null,
      isAuthenticated: false,
    }
  },
  computed: {
    passwordType() {
      return this.showPassword ? `text` : `password`;
    },
    stores() {
      return this.$store.getters.getAllStores;
    },
  },
  methods: {
    /**
     * Two-step login flow:
     * 1) Validate credentials via Vuex (POST /auth/login with { username, password })
     * 2) If successful, show store selector and on submit commit current store and navigate
     */
    login() {
      this.$utils.showLoading();

      if (!this.isAuthenticated) {
        const obj = { username: this.username, password: this.password };
        return this.$store.dispatch(`validateLogin`, obj)
          .then(res => {
            if (!res) return responses.showWarning(`Incorrect Username or Password`);
            this.isAuthenticated = true;
          })
          .finally(() => this.$utils.hideLoading());
      }

      // Step 2: Commit store selection and proceed
      if (!this.selectedStore) {
        this.$utils.hideLoading();
        return responses.showWarning(`Please select a store`);
      }

      this.$store.commit(`setCurrentStore`, this.selectedStore);
      this.$utils.hideLoading();
      return this.$router.push({ name: 'pending-orders' });
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  background: #1e88e5;
  color: white;
  font-weight: 600;
  display: block;
  height: 45px;
  flex: 1;
  border-radius: 5px; /* per guidelines: <= 5px */
}

.submit-btns {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.card {
  padding-left: 10px;
  padding-right: 10px;
  max-width: 400px;
  width: 95vw;
  position: relative;
  border-radius: 5px; /* keep corners subtle */
}
</style>
